import axios from "../axios";

export function fetchPublicAppointment(token) {
  return axios.get(`/service/reports/public_appointment/${encodeURIComponent(token)}`);
}

export function confirmPublicAppointment(token) {
  return axios.put(`/service/reports/public_appointment/${encodeURIComponent(token)}/confirm`);
}
